import { BidStatus } from '@b-stock/fe-core/bstock-next/queries'
import { Colors } from '@b-stock/fe-core/design-system'
import type { StoreFrontOptionsColumnLayoutDto } from '@b-stock/listing-api-client'

export const ColumnIdEnum = {
  checkbox: 'checkbox',
  action: 'action',
  bidStatus: 'bidStatus',
  bidSubmission: 'bidSubmission',
  bstockGrade: 'bstockGrade',
  buyingFormat: 'buyingFormat',
  capacity: 'capacity',
  carrier: 'carrier',
  categories: 'categories',
  condition: 'condition',
  currentBid: 'currentBid',
  currentBidWithStatus: 'currentBidWithStatus',
  endTime: 'endTime',
  inventoryType: 'inventoryType',
  listingId: 'listingId',
  listingType: 'listingType',
  sellerLotId: 'sellerLotId',
  manifest: 'manifest',
  memory: 'memory',
  minRequiredBid: 'minRequiredBid',
  model: 'model',
  numberOfBids: 'numberOfBids',
  packagingCondition: 'packagingCondition',
  photo: 'photo',
  pricePercentOfMsrp: 'pricePercentOfMsrp',
  quantity: 'quantity',
  seller: 'seller',
  sellerCollects: 'sellerCollects',
  sellerGrade: 'sellerGrade',
  shipmentServiceType: 'shipmentServiceType',
  title: 'title',
  totalMSRP: 'totalMSRP',
  unitPrice: 'unitPrice',
  url: 'url',
  warehouseLocation: 'warehouseLocation',
} as const
export type ColumnIdEnum = (typeof ColumnIdEnum)[keyof typeof ColumnIdEnum]

const columnIds = Object.values(ColumnIdEnum)

export const isColumnId = (x?: string): x is ColumnIdEnum =>
  !!columnIds.find((y) => x === y)

/**
 * The columns a storefront's custom layout names that this grid knows.
 *
 * If empty, the custom layout is discarded.
 */
export const getCustomLayoutColumnIds = (
  customColumnLayout?: StoreFrontOptionsColumnLayoutDto
): ColumnIdEnum[] => customColumnLayout?.columns.filter(isColumnId) ?? []

export const ColumnLayoutIdEnum = {
  ALL_AUCTIONS_GEN_MERCH: 'ALL_AUCTIONS_GEN_MERCH',
  STOREFRONT_GEN_MERCH: 'STOREFRONT_GEN_MERCH',
  STOREFRONT_MOBILE: 'STOREFRONT_MOBILE',
  STOREFRONT_MOBILE_ATT: 'STOREFRONT_MOBILE_ATT',
  STOREFRONT_MOBILE_T_MOBILE: 'STOREFRONT_MOBILE_T_MOBILE',
} as const
export type ColumnLayoutIdEnum =
  (typeof ColumnLayoutIdEnum)[keyof typeof ColumnLayoutIdEnum]

const columnLayoutIds = Object.values(ColumnLayoutIdEnum)

export const isColumnLayoutId = (x?: string): x is ColumnLayoutIdEnum =>
  !!columnLayoutIds.find((y) => x === y)

/**
 * Sentinel value for number columns when they should not render the value.
 *
 * NOTE: always return this sentinel value from the valueGetter to hide values.
 * Cell renderer is not used for export and must not be relied on to hide data.
 */
export const SENTINEL = -1

export const bidStatusBgColorMap: Partial<Record<BidStatus, string>> = {
  [BidStatus.LOSING]: Colors.Semantic.Error.background,
  [BidStatus.LOST]: Colors.Semantic.Error.background,
  [BidStatus.WINNING]: Colors.Semantic.Success.background,
  [BidStatus.WON]: Colors.Semantic.Success.background,
}
